import React, { useState, useEffect, useContext, useRef } from "react";
import Request from "common/Request";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";
import Table from "common/graphs/Table/Table";
import BqnContext from "common/BqnContext";
import { atBqnTarget } from "common/api";
import { doFileChange, handleSaveFile, handleFileChange } from "./utils";

const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
  padding: 0 25px;

  .dataTables_info,
  .dataTables_paginate,
  .dataTables_filter,
  .dataTables_length {
    display: none;
  }

  .btn-load {
    margin: 0 15px;
  }
`;

const LicenseReport = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [tableData, setTableData] = useState();
  const fileInputRef = useRef(null);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  const getLicense = () => {
    ifCl.run(atBqnTarget("show license", mode, bqnId)).then((response) => {
      const [header, ...rows] = response.trim(/\s/).split("\n");
      const headerAttrs = header.trim(/\s/).split(/\s+/);
      const indexHeaderMap = headerAttrs.reduce((acc, value, index) => {
        acc[index] = value;
        return acc;
      }, {});
      const tableRows = rows.reduce((acc, row) => {
        const rowAttrs = row.trim(/\s/).split(/\s+/);
        const tableRow = rowAttrs.reduce((accRow, attr, index) => {
          if (indexHeaderMap[index] === "EXPIRATION") {
            if (attr === "n/a") {
              accRow[indexHeaderMap[index]] = "unlimited";
            } else {
              accRow[indexHeaderMap[index]] = attr;
            }
          } else if (indexHeaderMap[index] === "STATIC") {
            if (attr === "yes") {
              accRow[indexHeaderMap[index]] = "File";
            } else if (attr === "no") {
              accRow[indexHeaderMap[index]] = "License server";
            } else {
              accRow[indexHeaderMap[index]] = "n/a";
            }
          } else {
            accRow[indexHeaderMap[index]] = attr;
          }
          return accRow;
        }, {});
        acc.push(tableRow);
        return acc;
      }, []);
      setTableData(tableRows);
    });
  };

  const columns = [
    ...(mode !== "standalone"
      ? [
          {
            label: "BQN",
            id: "BQN",
            title: "BQN ID",
            numeric: true,
          },
        ]
      : []),
    {
      label: "FEATURE",
      id: "FEATURE",
      numeric: false,
    },
    {
      label: "EXPIRATION",
      id: "EXPIRATION",
      numeric: false,
    },
    {
      label: "CAPACITY",
      id: "USAGE-MAX",
      numeric: false,
    },
    {
      label: "VALID",
      id: "VALID",
      numeric: false,
    },
    {
      label: "SOURCE",
      id: "STATIC",
      numeric: false,
    },
  ];

  const doLoad = () => {
    setRequest(getLicense());
  };

  useEffect(() => {
    doLoad();

    return actions.recv("do-load", doLoad);
  }, [mode, bqnId]);

  const handleLoadClick = () => {
    if (mode === "cluster") {
      actions.send("open-upload");
    } else {
      fileInputRef.current.click();
    }
  };

  const filteredData =
    mode === "standalone" || bqnId === "all"
      ? tableData
      : tableData?.filter((item) => item.BQN === bqnId.toString());

  return (
    <>
      <TableContainer>
        <button
          type="button"
          className="btn btn-default btn-load waves-effect shadow-none hidden-to-operators"
          onClick={handleLoadClick}
        >
          <i className="material-icons">add_circle</i>
          <span>Load license from file...</span>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </button>
        <Table columns={columns} data={filteredData} exportCSV={false} />
      </TableContainer>
    </>
  );
};

export default LicenseReport;
